import domtoimage from "dom-to-image-more";

export class MapScreenShotPrinter {
  /**
   *
   * @param {L.Map} map
   * @param {Object} [options]
   * @param {Number} [options.width] default: mapContainer.clientWidth
   * @param {Number} [options.height] default: mapContainer.clientHeight
   *
   * @return {Promise.<HTMLCanvasElement>}
   */
  static async print(map, options = {}) {
    const mapContainer = map.getContainer();

    // Hide all controls
    const controlsContainer = mapContainer.getElementsByClassName(
      "leaflet-control-container"
    )[0];
    const previousDisplayParam = controlsContainer.style.display;
    controlsContainer.style.display = "none";

    // Take Map Screen Shot
    const canvas = await domtoimage.toCanvas(mapContainer, {
      ...options,
      width: mapContainer.clientWidth,
      height: mapContainer.clientHeight
    });

    // Show all controls
    controlsContainer.style.display = previousDisplayParam;

    return canvas;
  }
}
